import { render } from "./fileSharePopup.vue?vue&type=template&id=37d1d094&scoped=true"
import script from "./fileSharePopup.js?vue&type=script&lang=js"
export * from "./fileSharePopup.js?vue&type=script&lang=js"

import "./fileSharePopup.vue?vue&type=style&index=0&id=37d1d094&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d1d094"]])

export default __exports__